<template>
    <div @click="fileClick()">
        <input
            type="file"
            ref="input"
            @change="handleFilesUpload($event)"
            style="display: none"
            :multiple="multiple"
            :accept="accept"
            capture="camera"
        />
        <slot></slot>
    </div>
</template>

<script>
// import { uploadImg } from '@/api/sys/FileUpload';

export default {
    name: 'ImgUpload',
    props: {
        type: {
            type: String,
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: 'image/*'
        }

    },
    methods: {
        // 点击选择图片按钮
        fileClick() {
            this.$refs.input.click();
        },
        handleFilesUpload(el) {
            if (el.target.files.length == 0) {
                return false;
            }
            let formData = new FormData();
            for (let file of el.target.files) {
                formData.append('files', file);
            }
            formData.append('busiType', this.type);
            uploadImg(formData).then((res) => {
                if (res) {
                    if (!this.multiple) {
                        res = res[0];
                    }
                    this.$refs.input.value = null;
                    this.$emit('input', res);
                    this.$emit('change', res);
                }
            });
        }

    }
};
</script>

<style>
</style>

